import clsx from 'clsx';
import { LegalCheckIcon } from '@ag1/ui';

import { useEffect } from 'react';
import { useFooterContext } from '../FooterContext';

import { FooterCookieConsentProps } from './types';
import styles from './styles.module.scss';

const FooterCookieConsent = ({ className }: FooterCookieConsentProps) => {
  const {
    data: { cookieConsent }
  } = useFooterContext();
  const labelConsent = cookieConsent?.label;
  const textConsent = cookieConsent?.text;

  const handleConsent = () => {
    if (window?.ketch) {
      window.ketch('showPreferences');
    }
  };

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    // Handles accessibility focus for Ketch’s banner button after it appears
    const handleKetchEvents = () => {
      // Add body class when cookie banner is about to be shown
      document.body.classList.add('has-cookie-banner');
      timeoutId = setTimeout(() => {
        const a11yButton = document.getElementById('usntA40Toggle');
        if (a11yButton) {
          a11yButton.setAttribute('tabindex', '0');
          a11yButton.focus();
        }
      }, 2000);
    };

    if (typeof window !== 'undefined' && window.ketch) {
      // Attach Ketch event listener for experience visibility
      window.ketch('on', 'willShowExperience', handleKetchEvents);
    }

    return () => {
      clearTimeout(timeoutId);
      // Clean up event listener on unmount
      window?.ketch('off', 'willShowExperience', handleKetchEvents);
    };
  }, []);

  useEffect(() => {
    // Removes body class when the banner is hidden or dismissed
    const removeClass = () => {
      document.body.classList.remove('has-cookie-banner');
    };

    if (window?.ketch) {
      // Listen for when the cookie consent banner is closed
      window.ketch('on', 'hideExperience', removeClass);
    }

    return () => {
      // Remove event listener on unmount
      window?.ketch?.('off', 'hideExperience', removeClass);
    };
  }, []);

  return (
    <div className={clsx(styles.content, className)}>
      <div id="consent-banner" className={styles.consentBanner} />
      <div id="teconsent" className={styles.teconsent} />
      <p>{textConsent}:&nbsp;&nbsp;</p>
      <button type="button" onClick={handleConsent} className={styles.btn}>
        <span>{labelConsent}</span>
        <span className={styles.icon}>
          <LegalCheckIcon />
        </span>
      </button>
    </div>
  );
};

export default FooterCookieConsent;
